const groupPrefix = createApiRoute(ApiModule.SYSTEM, ApiDataModel.CACHE)

export const apiCache = {
	clearCache: async () => {
		const { data } = await apiCommon(`${groupPrefix}/clear`, { method: 'POST' })
		return data
	},
}
